import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { AboutPage } from '@/components/marketing/AboutPage';

export const Route = createFileRoute('/_public/about')({
  component: () => (
    <MarketingShell currentPath="/about">
      <AboutPage />
    </MarketingShell>
  ),
});
